import { LearnerGoals_DailyGoalProgressStatus as ProgressStatus } from '__generated__/graphql-types';

import type { DailyGoalTypeNameString } from 'bundles/daily-goals/types';

export { ProgressStatus };

/**
 * Const object representing daily goal types with readable names but actual GraphQL __typename values
 * TypeScript enforces that all values must be valid DailyGoalTypeNameString values from GraphQL
 */
export const DailyGoalTypeNames = {
  AddCareerGoal: 'LearnerGoals_DailyGoalAddCareerGoal',
  CompleteAssessments: 'LearnerGoals_DailyGoalCompleteAssessments',
  CompleteHandsOnItems: 'LearnerGoals_DailyGoalCompleteHandsOnItems',
  CompleteItems: 'LearnerGoals_DailyGoalCompleteItems',
  CompleteLectures: 'LearnerGoals_DailyGoalCompleteLectures',
  CompleteModule: 'LearnerGoals_DailyGoalCompleteModule',
  CompletePractice: 'LearnerGoals_DailyGoalCompletePractice',
  CompleteReadings: 'LearnerGoals_DailyGoalCompleteReadings',
  PracticeWithCoach: 'LearnerGoals_DailyGoalPracticeWithCoach',
  ReturnToCoursera: 'LearnerGoals_DailyGoalReturnToCoursera',
  Score80PercentOnAssignment: 'LearnerGoals_DailyGoalScore80PercentOnAssignment',
  SetUpLearningPlan: 'LearnerGoals_DailyGoalSetUpLearningPlan',
  UnlockPersonalizedTracker: 'LearnerGoals_DailyGoalUnlockPersonalizedTracker',
  ContinueWeeklyStreak: 'LearnerGoals_DailyGoalContinueWeeklyStreak',
  MakeProgressOnWeeklyStreakTarget: 'LearnerGoals_DailyGoalMakeProgressOnWeeklyStreakTarget',
  StartWeeklyStreak: 'LearnerGoals_DailyGoalStartWeeklyStreak',
} as const satisfies Record<string, DailyGoalTypeNameString>;

export const WEEKLY_STREAK_GOAL_TYPE_NAMES = [
  DailyGoalTypeNames.ContinueWeeklyStreak,
  DailyGoalTypeNames.MakeProgressOnWeeklyStreakTarget,
  DailyGoalTypeNames.StartWeeklyStreak,
] as const satisfies Array<DailyGoalTypeNameString>;

export const DEFAULT_TOAST_AUTO_HIDE_DURATION_MS = 5000 as const;
export const TOAST_ICON_SIZE = 40 as const;

export const EXPANDED_DROPDOWN_MIN_WIDTH = 401;
export const HIDE_PROGRESS_BAR_WIDTH = 1060;
export const HIDE_GOAL_LABEL_AND_PROGRESS_BAR_WIDTH = 768;

export const WELCOME_PILL_FADE_DURATION_MS = 500;
export const WELCOME_PILL_VISIBILITY_DURATION_MS = 3000;
export const HIDE_PROGRESS_TRACKER_BREAKPOINT = 384;

export const BLACK_OVERLAY_ZINDEX = 1000000;

export const DAILY_GOALS_LIHP_ESTIMATED_COMPLETION_DATE_TEXT_WRAP_BREAKPOINT = 600;

export const WEEKLY_STREAKS_DEFAULT_TARGET_DAYS = 3;
